import {
  AiCreateArtworkModel,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  getAIMenu_pictureGraph_aiCreateArtworkOptionMenu,
  getCollectedStyleModelList_pictureSocialQuery_collectedStyleModelList,
  getCompetitionDetail_marketingModule_competition,
  pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo,
  TagType,
} from '~/graphqls/types'

export type ExtendsProduct = Omit<
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  '__typename'
> &
  Partial<
    Omit<pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo, '__typename'>
  >

export const modelOptions = [
  {
    name: '通用模型',
    model: AiCreateArtworkModel.STABLE_DIFFUSION,
    desc: '描人绘景，真实生动',
    tag: null,
    url: 'https://data.wujiebantu.com/FkSu6PFbYbbPCV3yFrvhxlKGytLE.png',
  },
  {
    name: '漫画模型',
    model: AiCreateArtworkModel.ANIME_DIFFUSION,
    desc: '激发想象创作二次元',
    tag: null,
    url: 'https://data.wujiebantu.com/FtUpm77YMFvSB-oqJrMlhSLwjoPq.png',
  },
  {
    name: '风格模型',
    model: AiCreateArtworkModel.STYLE,
    desc: '有趣多彩，一键上手',
    tag: null,
    url: 'https://data.wujiebantu.com/FvyozIoEydBKihWeIc3wiZJoDvFX.png',
  },
  {
    name: 'MJ模型',
    model: AiCreateArtworkModel.MIDJOURNEY,
    desc: '专业质量，表现力强',
    tag: null,
    url: 'https://data.wujiebantu.com/mmmj_00000_iSpt.png',
  },
]

export type AIOptions = getAIMenu_pictureGraph_aiCreateArtworkOptionMenu & {
  collectedStyleModelList?: getCollectedStyleModelList_pictureSocialQuery_collectedStyleModelList[]
}

/** 大赛详情字段 */
export interface IAICompetitionContentObj {
  /**
   * pc-大赛列表封面图
   */
  list_cover_pc?: string | null
  /**
   * h5-大赛列表封面图
   */
  list_cover_h5?: string | null
  /**
   * wujieai用的背景图
   */
  banner_cover: string | null
  /**
   * pc-banner图
   */
  banner_pc: string | null
  /**
   * pc-活动介绍
   */
  desc_pc: string | string[] | null
  /**
   * h5-banner图
   */
  banner_h5: string | null
  /**
   * h5-活动介绍
   */
  desc_h5: string | string[] | null
  /**
   * 分享描述
   */
  share_txt: string | null
  /**
   * 分享图标
   */
  share_icon: string | null
  /**
   * 获奖公示（PC）
   */
  award_announcement_p_c: string | string[] | null
  /**
   * 获奖公示（H5）
   */
  award_announcement_h5: string | string[] | null
  /**
   * 主题
   *  */
  theme: string
  /**
   * 投稿须知
   *  */
  contributeNotice: string
  /**
   * 隐藏文案
   */
  hiddenText?: boolean
  /**
   * 简介banner pc link
   */
  desc_banner_link_pc?: string
  /**
   * 简介banner h5 link
   */
  desc_banner_link_h5?: string
  /**
   * 简介banner pc
   */
  desc_banner_pc?: string
  /**
   * 简介banner h5
   */
  desc_banner_h5?: string
  /**
   * 主办方信息
   */
  host_list?: string
  /**
   *  外部合作大赛跳转链接PC
   *  */
  jump_url_pc: string
}

export interface IAICompetitionDetail
  extends getCompetitionDetail_marketingModule_competition,
    IAICompetitionContentObj {}

export enum ModelVersionEnum {
  SD15 = '1.x',
  SD20 = '2.x',
  SDXL = 'sdxl',
}

/**
 * 发送到参考图选项key和元素id统一管理
 * */
export enum ReferToScrollKeyEnum {
  referToImage = 'referToImage',
  referToStyle = 'referToStyle',
  referToRole = 'referToRole',
  referToStructure = 'referToStructure',
  mjReferToStyle = 'mjReferToStyle',
  mjReferToRole = 'mjReferToRole',
}
